module.exports = __webpack_public_path__ + "img/partnership_06.d88488da.jpg";